/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const cardPaymentMethodDetailsSchema = z.object({
	brand: z.string(),
	last4: z.string(),
	expMonth: z.number(),
	expYear: z.number(),
})

export type CardPaymentMethodDetailsSchema = z.infer<typeof cardPaymentMethodDetailsSchema>
